module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "FooterTY-cmp"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "edit-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "city-links"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("城市分布")]), _vm._v(" "), _c('div', {
    staticClass: "cont clearfix"
  }, _vm._l((_vm.hotelList), function(data, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": _vm.hostUrl + '/pc/search-hotel?hotelId=' + data.code
      }
    }, [_vm._v(_vm._s(data.name))])
  }), 0)])])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "footer-logo"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/yh/icon/gdhmlogo.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "links clearfix"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/about/hotel-alliance.html"
    }
  }, [_vm._v("业务拓展")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/about/join-us1.html"
    }
  }, [_vm._v("人才招聘")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "edit-container"
  }, [_c('div', {
    staticClass: "links"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/usage.html"
    }
  }, [_vm._v("使用条款")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/privacy.html"
    }
  }, [_vm._v("隐私声明")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.gdhhotels.com/about/contact-us.html"
    }
  }, [_vm._v("联系方式")])]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('span', [_vm._v("版权所有 粤海国际酒店管理（中国）有限公司")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("ICP备案号 粤ICP备06050136号")])]), _vm._v(" "), _c('span', [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030302002010"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    },
    attrs: {
      "src": require("../../assets/images/yh/beian.png")
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t粤公网安备 44030302002010号\n\t\t\t\t\t\t\t")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98548a84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FooterYH.vue
// module id = 598
// module chunks = 28